export default [
  {
    'added_by': 'Ignacio Ropolo',
    'content_type': 'image/gif',
    'date_added': 1730918926288,
    'image': 'https://storage.googleapis.com/uv-beta_custom_emojis/5646620347596800/blinkingguy',
    'name': 'blinkingguy',
    'unicode_output': '3a-62-6c-69-6e-6b-69-6e-67-67-75-79-3a',
    'shortname': ':blinkingguy:',
    'shortname_alternates': [],
    'custom': true,
  },
  {
    'added_by': 'Ignacio Ropolo',
    'content_type': 'image/jpeg',
    'date_added': 1730918772008,
    'image': 'https://storage.googleapis.com/uv-beta_custom_emojis/5646620347596800/awkward_seal',
    'name': 'awkward_seal',
    'unicode_output': '3a-61-77-6b-77-61-72-64-5f-73-65-61-6c-3a',
    'shortname': ':awkward_seal:',
    'shortname_alternates': [],
    'custom': true,
  },
  {
    'added_by': 'Ignacio Ropolo',
    'content_type': 'image/png',
    'date_added': 1730918828527,
    'image': 'https://storage.googleapis.com/uv-beta_custom_emojis/5646620347596800/baby_yoda',
    'name': 'baby_yoda',
    'unicode_output': '3a-62-61-62-79-5f-79-6f-64-61-3a',
    'shortname': ':baby_yoda:',
    'shortname_alternates': [],
    'custom': true,
  },
]
